import React, {useState} from "react";
import styles from './admin_sidebar.module.css';
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTags, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

export default function AdminSidebar({active}) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    const items = [
        {name: t('admin.sidebar.clients'), url: "/admin", icon: "/sidebar/people.png"},
        {name: t('admin.sidebar.deviceTypes'), url: "/admin/device_types", icon: "/sidebar/devices.png"},
        {name: t('admin.sidebar.paymentPlans'), url: "/admin/payment_plans", faIcon: faTags},
        {name: t('admin.sidebar.subscriptions'), url: "/admin/subscriptions", icon: "/sidebar/payments.png"},
    ]
    return (
        <>
            <button className={styles.hamburger} onClick={() => setIsOpen(!isOpen)}>
                <FontAwesomeIcon icon={isOpen ? faTimes : faBars}/>
            </button>
            {isOpen && <div className={styles.overlay} onClick={() => setIsOpen(false)}/>}
            <div className={`${styles.container} ${isOpen ? styles.open : ''}`}>
                <div className={`${styles.logoContainer} py-4`}>
                    <img alt={'logo'} src={'/mid_clear.png'} height={'36px'}/>
                </div>

                <div className={styles.sections}>
                    {items?.map((item, index) => (
                        <li key={index}>
                            <div className={`${active === index ? styles.active : ''} rounded-2`}>
                                <Link to={item.url} className="d-flex align-items-center" onClick={() => setIsOpen(false)}>
                                    {item.faIcon
                                        ? <FontAwesomeIcon icon={item.faIcon} style={{width: '24px', fontSize: '18px', color: '#a0aec0'}}/>
                                        : <img src={item.icon} alt={'sidebar_icon'} width={'24px'}/>
                                    }
                                    <div><span>{item.name}</span></div>
                                </Link>
                            </div>
                        </li>
                    ))}
                </div>
            </div>
        </>
    );
}